// https://vuex.vuejs.org/en/state.html

export default {
  isUserLoggedIn: false,
  mail: null,
  Token: null,
  userId: null,
  companyId: null,
  userType: null,
  username: null,
  project: null,
  projects: null,
  projectsArr: [],
  subProjectsArr: [],
  subProject: null,
  devices: [],
  data: null,
  data2: null,
  alerts: 0,
  alertsResolved: 0,
  agroBot: null,
  agroBotComp: null,
  agroBotBasic: null,
  agroBotLight: null,
  agroBotSoil: null,
  agroBee: null,
  CEReports: null,
  meteo: null,
  modal: null,
  modal2: null,
  modal3: null,
  agroUnits: null,
  agroUnitsIds: [],
  subProjectId: null,
  irrigationInstructions: null,
  splitIrrigationInstructions: [],
  splitPulses: [],
  pulses: null,
  pulsesTable: null,
  pulsesHeaders: null,
  configPulse: null,
  proDevices: null,
};
